import { Component, OnInit,ViewEncapsulation} from '@angular/core';
import { FormControl, FormGroup, Validators, NgForm ,FormBuilder} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'app/shared/auth/auth.service';
import { ApiService } from 'app/shared/services/api.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { NgbDateStruct, NgbDatepickerI18n, NgbCalendar} from '@ng-bootstrap/ng-bootstrap';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-attendance',
  templateUrl: './add-attendance.component.html',
  styleUrls: ['./add-attendance.component.scss']
  
})
export class AddAttendanceComponent implements OnInit {
  attendanceForm: FormGroup;
  usersList=[]
  selectedValue=null
  currentUser:any
  attendanceFormSubmitted=false;
  submitted = false;
 
  // meridian = true;
  // d3: any;
  // model: NgbDateStruct;
  constructor(private formBuilder: FormBuilder,
    public apiService:ApiService,
    public toastr: ToastrService,
    private route:Router,
    public authService:AuthService) { 
      this.currentUser=authService.currentUser()
      console.log('current user',this.currentUser)
    }

  ngOnInit(): void {
    this.getAllUsers()
    this.attendanceForm = this.formBuilder.group({
      user: ['', Validators.required],
      startTime: ['', Validators.required],
      endTime: ['', Validators.required],
      attendanceDate: ['', Validators.required],
      notes: ['', Validators.required],
      task: ['', Validators.required],      
    });
  }
   getAllUsers(){
    this.apiService.getAllUsers(1,100).subscribe((res:any)=>{
       this.usersList=res.data.items
    })
  }
  getUserId(event:any){
    console.log('user select',this.selectedValue)
  }
  get rf() {
    return this.attendanceForm.controls;
  }
  onTimeChange(value:{hour:string,minute:string})
  {
     console.log(value)
     let th= parseInt(value.hour)<10?`0${value.hour}`:`${value.hour}`
     let tm= parseInt(value.minute)<10?`0${value.minute}`:`${value.minute}`

     return `${th}:${tm}`;
  }
  // submitForm(){
  //   if(this.currentUser.role.type =='admin'){
  submitForm(){
     if(this.currentUser.roles=='admin'){
      var body1={
         user:this.selectedValue,
        startTime:this.onTimeChange(this.attendanceForm.value.startTime),
        endTime:this.onTimeChange(this.attendanceForm.value.endTime),
        attendanceDate:moment(this.attendanceForm.value.attendanceDate).format('DD-MM-YYYY'),
        notes:this.attendanceForm.value.notes,
        task:this.attendanceForm.value.task,
      }
      console.log('before body',body1)
      this.apiService.createAttendance(body1).subscribe((res:any)=>{
        if(res.isSuccess === true){
          this.toastr.success(res.message)
          console.log('create attendance',res)
          this.route.navigate(['/attendance/attendance-list'])
        }
        else {
          this.toastr.error(res.eror)
        }      
      })
    }
    else if(this.currentUser.roles =='student'){
      var body2={
        user:this.currentUser.id,
        startTime:this.onTimeChange(this.attendanceForm.value.startTime),
        endTime:this.onTimeChange(this.attendanceForm.value.endTime),
        attendanceDate:moment(this.attendanceForm.value.attendanceDate).format('DD-MM-YYYY'),
        notes:this.attendanceForm.value.notes,
        task:this.attendanceForm.value.notes,
      }
      console.log('before body',body2)
      this.apiService.createAttendance(body2).subscribe((res:any)=>{
        if(res.isSuccess === true){
          console.log('create attendance',res)
          this.route.navigate(['/attendance/attendance-list'])
        }
        else {
          this.toastr.error(res.eror)
        }   
      })
    }
    
  }
  back(){
    this.route.navigate(['/attendance/attendance-list'])
  }

  // isDisabled(date: NgbDateStruct, current: {month: number}) {
  //   return date.month !== current.month;
  // }
 
   
  //  isWeekend(date: NgbDateStruct) {
  //   const d = new Date(date.year, date.month - 1, date.day);
  //   return d.getDay() === +1 || d.getDay() === 6;
  // }
 

}
